export class Ambiente {

  public isAmbientePronto?: boolean;
  
  private keyDS: string;

  private nome: string;
  private urlHealthlog: string;
  private versaoAPI?: string;
  private arquivoLogoPequena?: string;
  private arquivoLogoPequenaColorida?: string;
  private arquivoLogoGrande?: string;
  private arquivoLogoGrandeHorizontal?: string;
  private favicon?: string;

  public toString?(): void {
    console.log('keyDS: ' + this.keyDS);
    console.log('nome: ' + this.nome);
    console.log('urlHealthlog: ' + this.urlHealthlog);
    console.log('versaoAPI: ' + this.versaoAPI);
    console.log('arquivoLogoPequena: ' + this.arquivoLogoPequena);
    console.log('arquivoLogoPequenaColorida: ' + this.arquivoLogoPequenaColorida);
    console.log('arquivoLogoGrande: ' + this.arquivoLogoGrande);
    console.log('arquivoLogoGrandeHorizontal: ' + this.arquivoLogoGrandeHorizontal);
    console.log('favicon: ' + this.favicon);
  }

  constructor() {
    this.keyDS = null;
    this.nome = null;
    this.urlHealthlog = null;
    this.isAmbientePronto = false;
    this.versaoAPI = null;
    this.arquivoLogoPequena = null;
    this.arquivoLogoPequenaColorida = null;
    this.arquivoLogoGrande = null;
    this.arquivoLogoGrandeHorizontal = null;
    this.favicon = null;
  }

  setKeyDS(value: string): Ambiente {
    this.keyDS = value;
    return this;
  }

  getKeyDS(): string {
    return this.keyDS;
  }

  getNome(): string {
    return this.nome;
  }

  setNome(value: string): Ambiente {
    this.nome = value;
    return this;
  }

  getUrlHealthlog(): string {
    return this.urlHealthlog;
  }

  setUrlHealthlog(value: string): Ambiente {
    this.urlHealthlog = value;
    return this;
  }

  getVersaoAPI(): string {
    return this.versaoAPI;
  }

  setVersaoAPI(value: string): Ambiente {
    this.versaoAPI = value;
    return this;
  }

  getArquivoLogoPequena(): string {
    return this.arquivoLogoPequena;
  }

  getArquivoLogoPequenaColorida(): string {
    return this.arquivoLogoPequenaColorida;
  }

  setArquivoLogoPequena(value: string): Ambiente {
    this.arquivoLogoPequena = value;
    return this;
  }

  setArquivoLogoPequenaColorida(value: string): Ambiente {
    this.arquivoLogoPequenaColorida = value;
    return this;
  }

  setArquivoLogoGrandeHorizontal(value: string): Ambiente {
    this.arquivoLogoGrandeHorizontal = value;
    return this;
  }

  getFavicon(): string {
    return this.favicon;
  }

  setFavicon(value: string): Ambiente {
    this.favicon = value;
    return this;
  }

  getArquivoLogoGrandeHorizontal(): string {
    return this.arquivoLogoGrandeHorizontal;
  }

  getArquivoLogoGrande(): string {
    return this.arquivoLogoGrande;
  }

  setArquivoLogoGrande(value: string): Ambiente {
    this.arquivoLogoGrande = value;
    return this;
  }


}
